<template>
  <div>
    <el-card>
      <alter-form @handleChange="handleChange" @handleAddFirstArray="afterAdd" :addFirstArray="true" :subFirstArray="true" @handleSubFirstArray="removeArray"  ref="alterForm" @formSubmit="formSubmit" :modifyData="modifyData" :formData="formData" :collapseLength="collapseLength" @switchChanged="handleSwitchChange"></alter-form>
    </el-card>
  </div>
</template>

<script>
import onlineCouponEdit from './index.js'
export default onlineCouponEdit
</script>

<style lang="scss" scope>
@import './index.scss';
</style>
